import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";
import type { SlackConfiguration } from "./SlackSourceSettings.types";

/**
 * A Slack connection imports nothing until reaction mode has a reaction, or List mode a List, so
 * it can't be saved without one. Connections saved for starred items have neither and must pick.
 */
export const getSlackSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  if (!editingConnection.isAuthorised) {
    return "";
  }

  const configuration = parseConnectionConfiguration<SlackConfiguration>(
    editingConnection.configuration,
  );

  if (configuration.mode === "lists") {
    return (configuration.lists ?? []).length > 0
      ? ""
      : t("board.connections.dialog.sourceSettings.slack.listRequired");
  }

  const hasReaction = (configuration.reactionNames ?? []).some(
    (name) => name.trim().length > 0,
  );

  return hasReaction
    ? ""
    : t("board.connections.dialog.sourceSettings.slack.reactionRequired");
};
